import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Box } from '@mui/material';
import { SCUIContent } from '../../../atomic/organisms';
import { SCUILoadingLinear } from '../../../atomic/atoms';
import { SCUIBreadCrumb } from '../../../atomic/molecules';
import { HiddenExcelDataGrid } from './HiddenExcelDataGrid';
import { HiddenExcelDrawer } from './HiddenExcelDrawer';
import { useHiddenExcelContext } from '../context/HiddenExcelContext';
import HiddenExcelQuery from '../../../services/query/hiddenExcel/HiddenExcelQuery.services';
import { HEX } from '../hiddenExcel.classes';

export const HiddenExcelLayout = () => {
    const { t } = useTranslation();
    const { isLoading, setIsLoading, setTables } = useHiddenExcelContext();

    useEffect(() => {
        const fetchTables = async () => {
            try {
                setIsLoading(true);
                const selectedCountry = localStorage.getItem('selectedCountry');
                const countryId = selectedCountry ? JSON.parse(selectedCountry)?.countryId : undefined;

                const response = await HiddenExcelQuery.GetHiddenExcelTables({
                    CountryId: countryId,
                });

                if (response) {
                    setTables(response);
                }
            } catch (error) {
                console.error('Error fetching hidden excel tables:', error);
            } finally {
                setIsLoading(false);
            }
        };

        fetchTables();
    }, [setIsLoading, setTables]);

    return (
        <SCUIContent>
            <Box className={HEX.page}>
                <div className={HEX.loadingSection}>
                    <SCUILoadingLinear display={isLoading} />
                </div>
                <div className={HEX.breadcrumbSection}>
                    <SCUIBreadCrumb title={t('hiddenExcel.title')} componentLink={'/hidden-excel'} />
                </div>
                <Box className={HEX.contentSection} sx={{ padding: '16px' }}>
                    <HiddenExcelDataGrid />
                    <HiddenExcelDrawer />
                </Box>
            </Box>
        </SCUIContent>
    );
};
